import { useState } from "react";
import { useConfirmation } from "../component/AppModal";

let csrfToken = null

export default function useFetch() {
  const confirm = useConfirmation()


  const [response, setResponse] = useState(null)
  const [error, setError] = useState(null)

  // Keep authentication same-origin in development. The dev server forwards
  // /api to REACT_APP_API (see setupProxy.js), so PHP's session cookie is not
  // treated as a third-party cookie by the browser.
  const api = process.env.NODE_ENV === 'development'
    ? '/api'
    : `${process.env.REACT_APP_API}/api`

  const parseResponse = async (res) => {
    const responseCsrfToken = res.headers.get('x-csrf-token')
    if (responseCsrfToken) {
      csrfToken = responseCsrfToken
    }

    if (res.status === 401 && window.location.pathname !== '/login') {
      window.location.assign('/login')
      throw new Error('Session expired')
    }

    const contentType = res.headers.get('content-type') || ''
    if (!contentType.includes('application/json')) {
      throw new Error(`Unexpected response from API (${res.status})`)
    }

    return res.json()
  }


  const post = (route, params = null, invalid = null, after = null, error = null) => {

    setError(null)
    let body = new FormData()
    let status
    if (params) {
      Object.keys(params).forEach(key => {
        // FormData coerces null and undefined to the literal strings
        // "null" and "undefined". Optional fields must be omitted instead,
        // otherwise API updates can mistakenly try to persist those strings.
        if (params[key] !== null && params[key] !== undefined) {
          body.append(key, params[key])
        }
      })
    }

    const headers = csrfToken ? { 'X-CSRF-Token': csrfToken } : {}

    fetch(`${api}${route}`, {
      method: 'POST',
      body,
      headers,
      credentials: "include",
    }).then(res => {

      status = res.ok
      return parseResponse(res)

    }).then(data => {

      if (!status) {
        const apiError = data?.error?.message || data?.message || data
        setError(apiError)
        if (invalid) {
          invalid(apiError)
        }
      } else {
        setResponse(data)
        if (after) {
          after(data)
        }
      }
      
    }).catch(err => {
      setError(err?.message || String(err))

      if (error) {
        error(err)
      }

      console.error(err)
    })

  }

  const get = (route, params = null, invalid = null, after = null, error = null) => {

    setError(null)
    let url = new URL(`${api}${route}`, window.location.origin)
    let urlQuery = url.searchParams;
    let status

    if (params) {
      Object.keys(params).forEach(key => {
        urlQuery.append(key, params[key])
      })
    }

    url = url.toString()

    return fetch(url, {
      method: 'GET',
      credentials: "include",
      cache: 'no-store',
    }).then(res => {

      status = res.ok
      return parseResponse(res)

    }).then(data => {

      if (!status) {
        const apiError = data?.error?.message || data?.message || data
        setError(apiError)
        if (invalid) {
          invalid(apiError)
        }
        return false
      } else {
        setResponse(data)
        if (after) {
          after(data)
        }
        return true
      }
      


    }).catch(err => {
      setError(err)

      if (error) {
        error(err)
      }

      console.error(err)
      return false
    })
  }


  const del = async (route, params = null,invalid=null, after = null, error = null, confirmation = null) => {
    const confirmationMessage = confirmation?.message || 'Möchten Sie diesen Eintrag wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.'
    const confirmationTitle = confirmation?.title || 'Löschen bestätigen'
    if (!await confirm(confirmationMessage, confirmationTitle)) return false
    params = params || {}
    params.method = 'delete'

    post(route, params,invalid, after, error)
    return true
  }

  const update = (route, params = null, invalid=null,after = null, error = null) => {
    params = params || {}
    params.method = 'put'

    post(route, params, invalid,after, error)
  }

  return {
    post,
    get,
    del,
    update,
    response,
    error
  }

}
